import { Component, Input, OnChanges } from '@angular/core';
import { AccountTransferData } from "../../../account-transfer/account-transfer.model";
import { HorizontalListData } from '../../../ui/horizontal-list/horizontal-list.model';
import { TransactionDetailsAdapter } from './transaction-details.data';

@Component({
    selector: 'ifc-transaction-details',
    templateUrl: './transaction-details.component.html',
    styleUrls: ['./transaction-details.component.scss'],
    providers: [TransactionDetailsAdapter],
    standalone: false
})
export class TransactionDetailsComponent implements OnChanges {
  @Input()
  data: AccountTransferData;

  items: HorizontalListData[];

  constructor(private adapter: TransactionDetailsAdapter) { }

  ngOnChanges(): void {
    this.items = this.adapter.adaptHorizontalListData(this.data);
  }
}
